import { Table } from "@/features/Table";
import { type D1StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterD1StaticDatumsSchema,
  FilterD1StaticDatums,
} from "./filter";
import { Clients } from "@/lib/clients";

import { Tables } from "@/gen/tableNames/tables";

export const D1StaticDatumsTable = () => {
  return (
    <Table<D1StaticDatum, FilterD1StaticDatumsSchema>
      label="Actifs"
      client={Clients.D1}
      table_name={Tables.D1_STATIC_DATA}
      columns={porfolios_columns}
      filter={<FilterD1StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${Clients.D1}/${Tables.D1_STATIC_DATA}/new`,
        },
      ]}
    />
  );
};
